import { GoogleLatLngBounds, LatLngBounds } from '@sales-app/context/searchMap'

export function transformGoogleBounds(bounds: GoogleLatLngBounds): LatLngBounds {
  const ne = bounds.getNorthEast()
  const sw = bounds.getSouthWest()
  return {
    ne: ne?.toJSON(),
    sw: sw?.toJSON(),
  }
}

export function transformClusterBounds(bounds: LatLngBounds | null): any {
  if (!bounds) {
    return
  }
  const { nw, se } = bounds
  if (!nw || !se) {
    return
  }
  return [nw.lng, se.lat, se.lng, nw.lat]
}

function checkWithinBounds(sw, ne, pointer, google) {
  const swPoint = new google.LatLng(sw.lat, sw.lng)
  const nePoint = new google.LatLng(ne.lat, ne.lng)
  const bounds = new google.LatLngBounds(swPoint, nePoint)
  return bounds.contains(new google.LatLng(pointer.lat, pointer.lng))
}

export function getQuadrantValue(bounds, center, markerPosition, google) {
  const { ne, sw } = bounds

  if (checkWithinBounds(center, ne, markerPosition, google)) {
    return { north: true, east: true }
  } // Top Right

  if (checkWithinBounds(sw, center, markerPosition, google)) {
    return { south: true, west: true }
  } // Bottom Left

  if (checkWithinBounds({ lat: sw.lat, lng: center.lng }, { lat: center.lat, lng: ne.lng }, markerPosition, google)) {
    return { south: true, east: true }
  } // Bottom Right

  if (checkWithinBounds({ lat: center.lat, lng: sw.lng }, { lat: ne.lat, lng: center.lng }, markerPosition, google)) {
    return { north: true, west: true }
  } // Top Left
}
function getHalfNE(ne, center, google) {
  const swPoint = new google.LatLng(center.lat, center.lng)
  const nePoint = new google.LatLng(ne.lat, ne.lng)
  const bounds = new google.LatLngBounds(swPoint, nePoint)

  return bounds.getCenter()
}

function getHalfSW(sw, center, google) {
  const swPoint = new google.LatLng(sw.lat, sw.lng)
  const nePoint = new google.LatLng(center.lat, center.lng)
  const bounds = new google.LatLngBounds(swPoint, nePoint)
  return bounds.getCenter()
}

export function isInCenterHalf(bounds, center, markerPosition, google) {
  const { ne, sw } = bounds
  const googleRef = google
  const halfNE = getHalfNE(ne, center, googleRef)
  const halfSW = getHalfSW(sw, center, googleRef)

  return checkWithinBounds(
    { lat: halfSW.lat(), lng: sw.lng },
    { lat: halfNE.lat(), lng: ne.lng },
    markerPosition,
    google,
  )
}

export function LatLngToPoint(map, latLng) {
  if (!map || !latLng) return null
  const projection = map?.getProjection()
  const bounds = map?.getBounds()
  const topRight = projection?.fromLatLngToPoint(bounds.getNorthEast())
  const bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest())
  const scale = Math.pow(2, map?.getZoom())
  const worldPoint = projection.fromLatLngToPoint(latLng)
  return { x: Math.floor((worldPoint.x - bottomLeft.x) * scale), y: Math.floor((worldPoint.y - topRight.y) * scale) }
}
